/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserProfilePrivateRequest } from './UserProfilePrivateRequest';
import {
    UserProfilePrivateRequestFromJSON,
    UserProfilePrivateRequestFromJSONTyped,
    UserProfilePrivateRequestToJSON,
} from './UserProfilePrivateRequest';

/**
 * 
 * @export
 * @interface PatchedUserPrivateRequest
 */
export interface PatchedUserPrivateRequest {
    /**
     * 
     * @type {UserProfilePrivateRequest}
     * @memberof PatchedUserPrivateRequest
     */
    profile?: UserProfilePrivateRequest;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserPrivateRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserPrivateRequest
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedUserPrivateRequest
     */
    last_name?: string;
}

/**
 * Check if a given object implements the PatchedUserPrivateRequest interface.
 */
export function instanceOfPatchedUserPrivateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchedUserPrivateRequestFromJSON(json: any): PatchedUserPrivateRequest {
    return PatchedUserPrivateRequestFromJSONTyped(json, false);
}

export function PatchedUserPrivateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedUserPrivateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile': !exists(json, 'profile') ? undefined : UserProfilePrivateRequestFromJSON(json['profile']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function PatchedUserPrivateRequestToJSON(value?: PatchedUserPrivateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile': UserProfilePrivateRequestToJSON(value.profile),
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

